import { type QuickActionPageGroup } from 'src/components/QuickActions/quick-action-pages.types';
import { matchesWordStarts } from 'src/utils/strings';

// shorter prefixes ("s", "se") would dump a whole group while the user is typing something else
const GROUP_REVEAL_MIN_LENGTH = 3;

export const filterQuickActionPageGroups = (
  groups: QuickActionPageGroup[],
  term: string,
): QuickActionPageGroup[] => {
  const query = term.trim().toLowerCase();
  if (!query) {
    return [];
  }

  const hasSeveralWords = /\s/.test(query);

  return groups
    .map((group) => {
      const revealsGroup =
        !hasSeveralWords &&
        query.length >= GROUP_REVEAL_MIN_LENGTH &&
        group.title.toLowerCase().startsWith(query);

      if (revealsGroup) {
        return group;
      }

      return {
        ...group,
        pages: group.pages.filter(
          (page) =>
            matchesWordStarts(page.title, query) ||
            (hasSeveralWords && matchesWordStarts(`${group.title} ${page.title}`, query)),
        ),
      };
    })
    .filter((group) => group.pages.length);
};
